import { callApiToServer } from "../callApi";

export async function addModule(authtoken, moduleObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(moduleObject);

    let endUrl = "v1/auth/admin/add-course-session-topic";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
